import { useRef } from 'react';

// persist swr results during new fetch https://github.com/vercel/swr/issues/192
export const useStickyResult = (value): typeof value => {
  const val = useRef({});
  if (value !== undefined) val.current = value;
  return val.current;
};
